import { createRoot } from "react-dom/client"

import EntityIndex, { EntityIndexProps } from "./components/entity-index"

export default function indexSearchRoot(
  el: HTMLElement,
  entityIndexProps: EntityIndexProps
) {
  const root = createRoot(el)

  root.render(<EntityIndex {...entityIndexProps} />)
}
